import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ImageMissingPlaceholder from './ImageMissingPlaceholder';
import imageType from '../../types/image';
import { Tooltip } from '@material-ui/core';

const useStyles = makeStyles({
  image: {
    width: '100%',
    cursor: 'pointer'
  }
});

// Prevent dragging images between steps
function handleDragStart(e) {
  e.preventDefault();
}

const Image = ({ image, className, dishLabel }) => {
  const classes = useStyles();
  if (!image) {
    return <ImageMissingPlaceholder className={className} />;
  }

  return (
    <>
      {dishLabel ? (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'relative',
            border: '1px solid #dfdfdf'
          }}
        >
          <img
            src={
              dishLabel && dishLabel.dishLogo && dishLabel.dishLogo.thumbnailUrl
            }
            alt=""
            style={{
              height: '30px',
              width: '30px',
              position: 'absolute',
              zIndex: '1',
              top: '5px',
              left: '5px'
            }}
          />
          <Tooltip title="Update Image">
            <img
              src={image.thumbnailUrl}
              className={cx(classes.image, className)}
              alt=""
              onDragStart={handleDragStart}
            />
          </Tooltip>
        </div>
      ) : (
        <Tooltip title="Update Image">
          <img
            src={image.thumbnailUrl}
            className={cx(classes.image, className)}
            alt=""
            onDragStart={handleDragStart}
          />
        </Tooltip>
      )}
    </>
  );
};

Image.propTypes = {
  image: imageType,
  className: PropTypes.string
};

export default Image;
